import React from 'react';
import { GoogleApiWrapper, Map, Marker } from 'google-maps-react';
import { GOOGLE_MAP } from '../config/fbConfig';

class BusinessMap extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <Map
        google={this.props.google}
        zoom={18}
        onReady={this.props.fetchPlaces}
        initialCenter={{
          lat: 4.824167,
          lng: 7.033611,
        }}
        center={this.props.center}
        onClick={this.props.onMapClicked}>
        <Marker
          draggable={true}
          onDragend={this.props.moveMarker}
          position={this.props.center}
          name={'Current location'}
        />
      </Map>
    );
  }
}

export default GoogleApiWrapper({
  apiKey: GOOGLE_MAP,
})(BusinessMap);
